/* eslint-disable react/no-array-index-key */
import { useState } from "react";
import styled from "styled-components";

import CITY_LIST from "../../cms/city-data";

const CityDropdown = ({ onChange, value, margin, bgColor, cityList }) => {
	const [cityData] = useState(Array.isArray(cityList) ? cityList : CITY_LIST);
	return (
		<Container>
			<Wrapper margin={margin}>
				<Select onChange={onChange} value={value} bgColor={bgColor}>
					{cityData.map((item, index) => (
						<option key={index} value={item.id}>
							{item.name}
						</option>
					))}
				</Select>
			</Wrapper>
		</Container>
	);
};

// Styles
const Container = styled.div``;
const Wrapper = styled.div`
	margin: ${(props) => (props.margin ? props.margin : "0px")};
`;
const Select = styled.select`
	cursor: pointer;
	border-radius: 14px;
	padding: 2px 6px;
	border: none;
	background-color: ${(props) => (props.bgColor ? props.bgColor : "#4d3951")};
	color: #fff;
	display: block;
	font-size: 14px;
	font-weight: 500;
	line-height: 1.3;
	padding: 5px 30px 5px 15px;
	width: 100%;
	max-width: 100%; /* useful when width is set to anything other than 100% */
	box-sizing: border-box;
	margin: 0;
	border: none;
	border-radius: 14px;
	-moz-appearance: none;
	-webkit-appearance: none;
	appearance: none;
	/* note: bg image below uses 2 urls. The first is an svg data uri for the arrow icon, and the second is the gradient. 
		for the icon, if you want to change the color, be sure to use "%23" instead of "#", since it's a url. You can also swap in a different svg icon or an external image reference
		
	*/
	background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2016%2016%22%3E%3Cpath%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%20stroke%3D%22%23FFF%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%221.5%22%20d%3D%22M6%204L10%208%206%2012%22%20transform%3D%22rotate(90%208%208)%22%2F%3E%3C%2Fsvg%3E");
	background-repeat: no-repeat, repeat;
	/* arrow icon position (1em from the right, 50% vertical) , then gradient position*/
	background-position: right 0.7em top 50%, 0 0;
	/* icon size, then gradient */
	background-size: 16px auto, 100%;

	&::-ms-expand {
		display: none;
	}
	&:hover {
		box-shadow: 0 1px 0 1px rgba(0, 0, 0, 0.04);
	}
	&:focus {
		border: none; /* It'd be nice to use -webkit-focus-ring-color here but it doesn't work on box-shadow */
		box-shadow: 0 0 1px 3px rgba(77, 57, 81, 0.38);
		box-shadow: 0 0 0 3px -moz-mac-focusring;
		color: #fff;
		outline: none;
	}
	& option {
		font-weight: normal;
	}

	/* Disabled styles */
	&:disabled,
	&[aria-disabled="true"] {
		color: graytext;
		background-image: url("data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22graytext%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E");
	}

	&:disabled:hover,
	&[aria-disabled="true"] {
		border-color: #aaa;
	}
`;

export default CityDropdown;
